import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GenericPageService } from 'src/app/generic-page/generic-page.service';
import { LanguageService } from '../../shared/services/language.service';

const staticKnownSlugs = [
  'about-us',
  'how-works-memorabid',
  'how-works-auctions',
  'direct-bidding',
  'product-types',
  'payments-shipments',
  'become-seller',
  'terms-conditions',
  'privacy-policy',
  'cookie-policy',
  'blog',
  'testimonials',
  'news',
];

// Guard that checks if a page slug exists; if not, returns false so router keeps trying other routes.
export const slugPageExistsGuard: CanMatchFn = (
  _route: Route,
  segments: UrlSegment[]
) => {
  if (!segments || segments.length === 0) return false;
  // Support both ':slug' and ':lang/:slug' duplicated variants: take last segment as slug
  const slug = segments[segments.length - 1].path;

  if (!slug || slug.trim().length === 0) {
    return false;
  }

  if (staticKnownSlugs.includes(slug)) {
    return true;
  }

  // Basic quick exclusions (already covered by explicit routes) optional
  const pagesService = inject(GenericPageService);
  const languageService = inject(LanguageService);
  const idLanguage = languageService.userSelectedLanguage?.idLanguage ?? 1;

  if (!idLanguage) {
    return false;
  }
  return pagesService.getBySlug(slug, idLanguage).pipe(
    map((res) => !!res || staticKnownSlugs.includes(slug)),
    catchError(() => of(false))
  );
};
